/* Catalog Library section: Fuse.js fuzzy search + faceted browse (brand / industry /
   activity tiles), selected-filter chips, sort rules. Progressive enhancement over the
   server-rendered grid. */
(() => {
  const FALLBACK_ICON =
    '<svg width="22" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true"><path d="M4.5 4.5h6l2 2.5h7v12.5h-15z"/></svg>';

  /* Built-in brand tile icons, keyed by lowercased tag name. Apple and Zebra use
     their real logo marks (Simple Icons, CC0); the rest are product glyphs until
     official logos are uploaded via Filter tile blocks, which always override. */
  const BUILTIN_BRAND_ICONS = {
    'apple':
      '',
    'zebra':
      '<svg viewBox="0 8 6.6 8" fill="currentColor" aria-hidden="true"><path d="M5.145 13.109H4.6v-1.545l.545.546v.999zm-2.183-.095.546.546v.771L2.417 13.24v-3.092L1.003 8.739a2.73 2.73 0 0 1 .465-.306l1.494 1.489V8.126a.899.899 0 0 1 .084 1.793h.7l.002.003.543.543H2.962v2.549zm.546-2.545-.003 2.636h.546l.002-2.088-.545-.548zm1.873 1.095-.546-.546h-.781l.545.546h.782zm-3.51 1.162v-2.348L.616 9.125c-.118.143-.221.299-.308.464l1.016 1.016v.771L.093 10.144c-.059.217-.09.445-.093.68l1.87 1.902zM.01 11.604v.772l3.498 3.499v-.772L.01 11.605zm6.227.815h-.546v.69h-.546a.899.899 0 1 0 1.798 0l-.706-.69zm2.977.701 1.658-3.186h-2.55l-.41.78h1.469l-1.659 3.185h2.551l.41-.779H9.213zm2.95-2.407h1.307v-.779h-2.27V13.9h2.27v-.778h-1.308v-.82h1.308v-.78h-1.308v-.808zm1.78-.779V13.9h1.622c.404 0 .642-.053.838-.184.256-.173.404-.5.404-.868 0-.291-.089-.523-.267-.69-.125-.119-.232-.172-.476-.226.214-.059.303-.112.416-.231a.937.937 0 0 0 .268-.69c0-.38-.167-.72-.44-.886-.214-.136-.505-.19-1.01-.19h-1.356zm.962.72h.226c.452 0 .636.136.636.457 0 .327-.184.464-.624.464h-.238v-.921zm0 1.622h.22c.291 0 .387.012.493.072.143.077.214.214.214.404 0 .32-.172.458-.576.458h-.35v-.934zm3.239.09.868 1.533h1.153l-.874-1.456c.511-.202.767-.6.767-1.207 0-.434-.155-.79-.428-1.005-.262-.202-.642-.297-1.165-.297h-1.284V13.9h.963v-1.533zm0-.541v-1.1h.368c.34 0 .571.226.571.553 0 .344-.238.547-.63.547h-.309zm4.566 1.294h-1.285l-.245.78h-1.015l1.308-3.964h1.224L24 13.899h-1.045l-.244-.78zm-.244-.78-.398-1.269-.398 1.27h.796z"/></svg>',
    'samsung':
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="6.5" y="2.5" width="11" height="19" rx="2.2"/><line x1="10" y1="18.4" x2="14" y2="18.4" stroke-linecap="round"/></svg>',
    'honeywell': { img: 'https://rammount.com/cdn/shop/files/honeywell-logo.png?width=240', wordmark: true },
    'getac': { img: 'https://rammount.com/cdn/shop/files/Getac_Technology_Logo-small.png?width=240', wordmark: true },
    'nexa': { img: 'https://rammount.com/cdn/shop/files/NEXA_Logo_Black.png?width=240', wordmark: true },
    'gds\u00ae tech\u2122':
      '<svg viewBox="0 0 24 24" fill="none" stroke="#0FAF8E" stroke-width="2.4" aria-hidden="true"><rect x="3.2" y="3.2" width="17.6" height="17.6"/><path d="M14.8 8.6H9.4v6.8h5.4v-3.4h-2.7"/></svg>',
    'ram\u00ae mounts':
      '<svg viewBox="0 0 24 24" fill="none" stroke="#E3371E" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true"><path d="M12 2.5l8 3.2v6c0 4.8-3.3 8.4-8 9.8-4.7-1.4-8-5-8-9.8v-6l8-3.2z"/></svg>'
  };


  /* Built-in industry tile icons, keyed by lowercased tag name. A merchant-uploaded
     "Filter tile" icon block always overrides these. Strokes inherit tile color. */
  const BUILTIN_INDUSTRY_ICONS = {
    'accessibility':
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="4.5" r="1.9" fill="currentColor" stroke="none"/><path d="M4.5 8.5c5 1.3 10 1.3 15 0M12 9.5v5M12 14.5l-3.5 6M12 14.5l3.5 6"/></svg>',
    'agriculture':
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 21c0-6 2.5-10.5 8.5-13.5C20.5 14 17 19 12 21z"/><path d="M12 21c0-5-2-8.5-8.5-11C3.5 15.5 6.5 19.5 12 21z"/></svg>',
    'aviation':
      '<svg width="25" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M21.5 15.5v-2l-8-5v-5c0-.9-.7-1.5-1.5-1.5s-1.5.6-1.5 1.5v5l-8 5v2l8-2.5v5l-2.5 1.9v1.6l4-1.2 4 1.2v-1.6L13.5 18v-5l8 2.5z"/></svg>',
    'enterprise':
      '<svg width="22" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true"><path d="M4.5 21V4.5h9V21M13.5 9.5h6V21M3 21h19"/><line x1="7" y1="8" x2="10.5" y2="8"/><line x1="7" y1="12" x2="10.5" y2="12"/><line x1="7" y1="16" x2="10.5" y2="16"/></svg>',
    'healthcare':
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true"><path d="M12 3.5l7.5 3v5.5c0 4.5-3.1 7.9-7.5 9.2-4.4-1.3-7.5-4.7-7.5-9.2V6.5l7.5-3z"/><path d="M12 8v7M8.5 11.5h7" stroke-linecap="round"/></svg>',
    'material handling':
      '<svg width="25" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="12.5" width="8" height="6.5"/><path d="M11 15h4.5l2-4H11z"/><circle cx="6" cy="21" r="1.4"/><circle cx="13.5" cy="21" r="1.4"/><path d="M17.5 15V6.5" stroke-linecap="round"/><path d="M17.5 6.5h3.5v12" stroke-linecap="round"/></svg>',
    'public safety':
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true"><path d="M12 2.5l8 3.2v6c0 4.8-3.3 8.4-8 9.8-4.7-1.4-8-5-8-9.8v-6l8-3.2z"/><path d="M12 7.5l1.3 2.7 3 .4-2.2 2.1.5 2.9-2.6-1.4-2.6 1.4.5-2.9-2.2-2.1 3-.4L12 7.5z" fill="currentColor" stroke="none"/></svg>',
    'recreation':
      '<svg width="26" height="24" viewBox="0 0 26 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 19.5l7-11 4.5 7 3-4.5 6.5 8.5z"/><circle cx="18.5" cy="6" r="2"/></svg>',
    'retail':
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9.5" cy="20" r="1.5"/><circle cx="17.5" cy="20" r="1.5"/><path d="M3 3.5h2.5L8 15.5h11l2.5-9H6"/></svg>',
    'transportation':
      '<svg width="26" height="24" viewBox="0 0 26 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="7" width="13" height="9.5"/><path d="M15 10h4.5l3 3.5v3h-7.5z"/><circle cx="6.5" cy="18.7" r="1.6"/><circle cx="18.5" cy="18.7" r="1.6"/></svg>'
  };

  /* Built-in activity tile icons, keyed by lowercased tag name. A merchant-uploaded
     "Filter tile" icon block always overrides these. Strokes inherit tile color. */
  const BUILTIN_ACTIVITY_ICONS = {
    'bicycle':
      '<svg width="26" height="24" viewBox="0 0 26 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="6" cy="16.5" r="4"/><circle cx="20" cy="16.5" r="4"/><path d="M6 16.5l4.5-8h7l2.5 8M13 16.5l-2.5-8M9 8.5h3.5"/></svg>',
    'off-road':
      '<svg width="26" height="24" viewBox="0 0 26 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.5 17v-4.5l2-4.5h9l5.5 3h2.5V17"/><circle cx="8" cy="18" r="2.3"/><circle cx="18" cy="18" r="2.3"/><path d="M10.3 18h5.4M3.5 18h2.2M20.3 18h2.2"/></svg>',
    'on-road':
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M9.5 4.5L5 19.5M14.5 4.5L19 19.5"/><path d="M12 5.5v3M12 11v3M12 16.5v3"/></svg>',
    'on-water':
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4.5 15.5h15l-2.2 3.5H6.7z"/><path d="M12 3.5v12M12 4.5l5.5 8.5H12z"/></svg>',
    'powersports':
      '<svg width="26" height="24" viewBox="0 0 26 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="5.5" cy="17" r="3.2"/><circle cx="20.5" cy="17" r="3.2"/><path d="M5.5 17l4-7h6l3 7M9.5 10h4M15.5 10l2-2.5h2.5"/></svg>'
  };

  /* A-to-Z title sorting skips punctuation and symbols (+, registered and
     trademark marks) so co-branded titles like "Apple + RAM Healthcare" land
     after the base "Apple Catalog". Punctuation runs collapse to one space;
     Intl's ignorePunctuation is not used because it leaves a double space
     behind, which still sorts before letters. */
  const alphaKey = (title) => String(title).replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  const alphaCompare = (a, b) => alphaKey(a).localeCompare(alphaKey(b)) || a.localeCompare(b);

  const splitTags = (str) =>
    String(str || '')
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean);

  /* Escape text and wrap registered / trademark symbols in <sup> */
  const supTrademarks = (text) =>
    String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/[\u00ae\u2122]/g, (m) => '<sup>' + m + '</sup>');

  class CatalogLibrary extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      const dataEl = this.querySelector('[data-catlib-data]');
      if (!dataEl) return;
      let payload;
      try {
        payload = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      /* Theme-asset brand logos from the Liquid payload override the built-ins */
      Object.assign(BUILTIN_BRAND_ICONS, payload.brandIcons || {});

      this.cards = [...this.querySelectorAll('[data-catlib-card]')];
      this.items = payload.items.map((item, i) => ({
        idx: i,
        title: item.title || '',
        /* Join key into the compiled search corpus (block "Search data slug") */
        slug: String(item.slug || '').trim().toLowerCase(),
        /* Comma-separated like industries/activities: a multi-partner catalog
           (e.g. GDS) joins every listed brand's tile */
        brands: splitTags(item.brand),
        industries: splitTags(item.industries),
        activities: splitTags(item.activities),
        types: splitTags(item.types),
        keywords: splitTags(item.keywords),
        badge: String(item.badge || '').trim(),
        isNew: /^new$/i.test(String(item.badge || '').trim()),
        isUpdated: /^updated$/i.test(String(item.badge || '').trim()),
        /* Upload date (YYYY-MM-DD or year) as a timestamp; 0 sorts last */
        date: Date.parse(String(item.date || '').trim()) || 0,
        /* Optional fan position number; null when the block setting is blank */
        fanPos: typeof item.fanPos === 'number' ? item.fanPos : null,
        url: item.url || '',
        img: item.img || null,
        /* Compiled-corpus fields, filled by loadSearchData when the
           pages.catalog_search_data metafield provides catalog-search.json */
        extSkus: [],
        extDevices: [],
        extVehicles: [],
        extLines: [],
        extKeywords: [],
        extTags: []
      }));

      /* Fan hero: every catalog in block order, FAN_MAX per page (keep in sync
         with the Liquid limit); searching or filtering re-fans to the matches.
         Small screens hide the fan entirely via CSS. */
      this.FAN_MAX = 16;
      this.fanEl = this.querySelector('[data-catlib-fan]');
      this.fanStatus = this.querySelector('[data-catlib-fan-status]');
      this.fanPrev = this.querySelector('[data-catlib-fan-prev]');
      this.fanNext = this.querySelector('[data-catlib-fan-next]');
      /* Unfiltered fan order comes from the Fan order setting; "block" keeps the
         merchant's drag order, the others sort a copy of the items list. */
      const fanSort = this.dataset.fanSort || 'alpha';
      let fanItems = this.items;
      if (fanSort === 'alpha') {
        fanItems = [...this.items].sort((a, b) => alphaCompare(a.title, b.title));
      } else if (fanSort === 'new') {
        fanItems = [...this.items].sort(
          (a, b) => b.date - a.date || b.isNew - a.isNew || a.idx - b.idx
        );
      } else if (fanSort === 'block') {
        /* Fan position numbers first (lowest leads), the rest keep block order,
           so the fan can be curated independently of the grid's Featured order */
        fanItems = [...this.items].sort(
          (a, b) =>
            (a.fanPos == null ? Infinity : a.fanPos) - (b.fanPos == null ? Infinity : b.fanPos) ||
            a.idx - b.idx
        );
      }
      this.defaultFan = fanItems.map((item) => item.idx);
      /* Fans larger than FAN_MAX page through in slices via the arrow buttons */
      this.fanPage = 0;
      this.fanSetKey = 'd:' + this.defaultFan.join(',');
      /* Seed with the server-rendered fan (always block order) so the first
         render only rebuilds when the sort setting actually reorders it */
      this.fanKey = this.items
        .map((item) => item.idx)
        .slice(0, this.FAN_MAX)
        .join(',');
      this.updateFanPop(Math.min(this.defaultFan.length, this.FAN_MAX) || this.FAN_MAX);
      window.addEventListener('resize', () => this.updateFanPop());

      /* Optional merchant-uploaded tile icons, keyed per group by lowercased tag name */
      this.iconMap = { brand: new Map(), industry: new Map(), activity: new Map() };
      this.tileOrder = { brand: new Map(), industry: new Map(), activity: new Map() };
      this.labelMap = { brand: new Map(), industry: new Map(), activity: new Map() };
      (payload.tiles || []).forEach((t) => {
        const name = (t.name || '').trim();
        if (!name || !this.iconMap[t.group]) return;
        if (t.icon) this.iconMap[t.group].set(name.toLowerCase(), t.icon);
        if (t.label) this.labelMap[t.group].set(name.toLowerCase(), t.label);
        this.tileOrder[t.group].set(name.toLowerCase(), t.position);
      });

      this.brands = this.collectTags((item) => item.brands, 'brand');
      this.industries = this.collectTags((item) => item.industries, 'industry');
      this.activities = this.collectTags((item) => item.activities, 'activity');

      this.grid = this.querySelector('[data-catlib-grid]');
      this.tilesEl = this.querySelector('[data-catlib-tiles]');
      this.chipsEl = this.querySelector('[data-catlib-chips]');
      this.activeRow = this.querySelector('[data-catlib-active-row]');
      this.countEl = this.querySelector('[data-catlib-count]');
      this.emptyEl = this.querySelector('[data-catlib-empty]');
      this.searchBox = this.querySelector('[data-catlib-search-box]');
      this.searchInput = this.querySelector('[data-catlib-search]');
      this.sortSelect = this.querySelector('[data-catlib-sort]');

      this.showCounts = this.dataset.showCounts === 'true';
      this.activeTab = 'brand';
      this.selected = { brand: new Set(), industry: new Set(), activity: new Set() };
      if (this.sortSelect) {
        /* Badge-driven sort options only appear when they can do something */
        const defaultSort = this.dataset.defaultSort || 'new';
        const newOption = this.sortSelect.querySelector('option[value="new"]');
        if (newOption && defaultSort !== 'new' && !this.items.some((i) => i.date || i.isNew)) {
          newOption.remove();
        }
        if (this.items.some((i) => i.isUpdated)) {
          const option = document.createElement('option');
          option.value = 'updated';
          option.textContent = 'Recently updated';
          this.sortSelect.appendChild(option);
        }
        this.sortSelect.value = defaultSort;
        if (this.sortSelect.selectedIndex < 0) this.sortSelect.selectedIndex = 0;
      }

      const threshold = Math.min(100, Math.max(0, parseInt(this.dataset.threshold, 10) || 38)) / 100;
      /* Compiled-corpus keys (ext*) weigh in below title/brand so an exact
         catalog-name match always outranks a part/device/vehicle hit; SKUs
         rank highest of the ext fields because a part-number search should
         land decisively. Kept on the instance so loadSearchData can rebuild. */
      this.fuseOptions = {
        keys: [
          { name: 'title', weight: 0.45 },
          { name: 'brands', weight: 0.2 },
          { name: 'industries', weight: 0.15 },
          { name: 'activities', weight: 0.15 },
          { name: 'types', weight: 0.1 },
          { name: 'keywords', weight: 0.1 },
          { name: 'extSkus', weight: 0.3 },
          { name: 'extDevices', weight: 0.12 },
          { name: 'extVehicles', weight: 0.12 },
          { name: 'extLines', weight: 0.12 },
          { name: 'extKeywords', weight: 0.1 },
          { name: 'extTags', weight: 0.08 }
        ],
        threshold,
        ignoreLocation: true,
        includeMatches: true,
        minMatchCharLength: 2
      };
      this.fuse = typeof Fuse === 'undefined' ? null : new Fuse(this.items, this.fuseOptions);

      /* Superscript trademark symbols in server-rendered card tags and fan labels */
      this.querySelectorAll('.catlib-tag, .catlib-fan__label').forEach((el) => {
        el.innerHTML = supTrademarks(el.textContent);
      });

      this.bindEvents();
      this.renderAll();
      this.loadSearchData(payload.searchDataUrl);
    }

    /* Compiled catalog search corpus: catalog-search.json in Shopify Files,
       referenced by the catalogs page pages.catalog_search_data metafield and
       built by the data pipeline from the parts/fitment CSVs. Entries join to
       catalog blocks via the block's "Search data slug" setting; on any
       failure (no metafield, fetch error, no matching slugs) search keeps
       running on block-level fields alone. */
    loadSearchData(url) {
      if (!url || !this.fuse) return;
      fetch(url)
        .then((res) => (res.ok ? res.json() : Promise.reject(new Error('HTTP ' + res.status))))
        .then((data) => {
          const bySlug = new Map();
          (data.catalogs || []).forEach((entry) => {
            if (entry && entry.slug) bySlug.set(String(entry.slug).toLowerCase(), entry);
          });
          let matched = 0;
          this.items.forEach((item) => {
            const ext = item.slug && bySlug.get(item.slug);
            if (!ext) return;
            matched += 1;
            item.extSkus = ext.skus || [];
            item.extDevices = ext.devices || [];
            item.extVehicles = ext.vehicles || [];
            item.extLines = ext.product_lines || [];
            item.extKeywords = ext.keywords || [];
            item.extTags = [].concat(ext.vehicle_tags || [], ext.accessories || [], ext.gds || []);
          });
          if (!matched) return;
          /* Rebuild the index; a fresh instance works on any Fuse version.
             Drop the memo so an in-flight query re-runs against the new index. */
          this.fuse = new Fuse(this.items, this.fuseOptions);
          this.searchCache = null;
          if (this.query()) this.renderAll();
        })
        .catch(() => {});
    }

    collectTags(getter, group) {
      const seen = new Map(); /* lowercased -> first-seen display casing */
      this.items.forEach((item) => {
        getter(item).forEach((tag) => {
          const key = tag.toLowerCase();
          if (!seen.has(key)) seen.set(key, tag);
        });
      });
      const order = this.tileOrder[group];
      return [...seen.values()].sort((a, b) => {
        const pa = order.get(a.toLowerCase());
        const pb = order.get(b.toLowerCase());
        if (pa != null && pb != null) return pa - pb;
        if (pa != null) return -1;
        if (pb != null) return 1;
        return a.localeCompare(b);
      });
    }

    bindEvents() {
      this.querySelectorAll('[data-catlib-tab]').forEach((tab) => {
        tab.addEventListener('click', () => {
          this.activeTab = tab.dataset.catlibTab;
          this.querySelectorAll('[data-catlib-tab]').forEach((t) => {
            t.classList.toggle('is-active', t === tab);
            t.setAttribute('aria-pressed', String(t === tab));
          });
          /* Switching Browse-by views starts fresh: tile selections from every
             group clear so tabs act as independent entry points (search stays) */
          const hadFilters =
            this.selected.brand.size > 0 ||
            this.selected.industry.size > 0 ||
            this.selected.activity.size > 0;
          this.selected.brand.clear();
          this.selected.industry.clear();
          this.selected.activity.clear();
          if (hadFilters) {
            this.renderAll();
          } else {
            this.renderTiles();
          }
        });
      });
      if (this.searchInput) {
        /* Trailing debounce collapses rapid keystrokes into one render pass
           (the fan and tile counts are the expensive part); the search box's
           Clear button visibility still reacts to every keystroke. */
        this.searchInput.addEventListener('input', () => {
          if (this.searchBox) this.searchBox.classList.toggle('has-value', this.query().length > 0);
          clearTimeout(this.searchDebounce);
          this.searchDebounce = setTimeout(() => this.renderAll(), 120);
        });
      }
      const searchClear = this.querySelector('[data-catlib-search-clear]');
      if (searchClear) {
        searchClear.addEventListener('click', () => {
          this.searchInput.value = '';
          this.searchInput.focus();
          this.renderAll();
        });
      }
      if (this.sortSelect) {
        this.sortSelect.addEventListener('change', () => this.renderGrid());
      }
      const clearAll = this.querySelector('[data-catlib-clear-all]');
      if (clearAll) clearAll.addEventListener('click', () => this.resetAll());
      const reset = this.querySelector('[data-catlib-reset]');
      if (reset) reset.addEventListener('click', () => this.resetAll());
      /* Browse all: drops the collapsed results area (chips, sort, grid) down
         and scrolls to it; falls back to a plain scroll when nothing collapses. */
      const browseAll = this.querySelector('[data-catlib-browse-all]');
      this.browseAllBtn = browseAll;
      this.browseEl = this.querySelector('[data-catlib-browse]');
      if (browseAll && this.browseEl) {
        browseAll.addEventListener('click', () => {
          const open = this.browseEl.hidden;
          this.browseEl.hidden = !open;
          browseAll.setAttribute('aria-expanded', String(open));
          browseAll.textContent = open ? 'Hide catalog list' : `Browse all (${this.items.length})`;
          this.updateActiveRow();
          if (open) this.browseEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      } else if (browseAll) {
        browseAll.addEventListener('click', () => {
          const target =
            this.querySelector('.catlib-search-wrap') ||
            this.querySelector('[data-catlib-facets]') ||
            this.grid;
          if (target) target.scrollIntoView({ behavior: 'smooth' });
        });
      }

      if (this.fanPrev) {
        this.fanPrev.addEventListener('click', () => {
          this.fanPage = Math.max(0, this.fanPage - 1);
          this.renderFan();
        });
      }
      if (this.fanNext) {
        this.fanNext.addEventListener('click', () => {
          this.fanPage += 1;
          this.renderFan();
        });
      }

      /* Mouse pointers pop covers from the pointer's x position over the fixed
         layout slots instead of :hover. The popped cover scales well past its
         slot, so hover-based popping flickers at cover edges (the scale pulls
         the cover out from under the pointer) and swallows the next cover when
         sweeping left to right; slot mapping is immune to both. */
      if (this.fanEl && window.matchMedia && window.matchMedia('(hover: hover)').matches) {
        this.fanEl.addEventListener('pointermove', (e) => {
          this.setFanActive(this.fanItemFromPoint(e.clientX));
        });
        this.fanEl.addEventListener('pointerleave', () => this.setFanActive(null));
      }

      /* Touch devices get tap-to-preview: the first tap lifts a cover and shows
         its title, a second tap on the lifted cover follows the link. Delegated
         so it survives fan rebuilds. */
      if (this.fanEl && window.matchMedia && window.matchMedia('(hover: none)').matches) {
        this.fanEl.addEventListener('click', (e) => {
          const item = e.target.closest('.catlib-fan__item');
          if (!item || item.classList.contains('is-active')) return;
          e.preventDefault();
          this.setFanActive(item);
        });
        document.addEventListener(
          'click',
          (e) => {
            if (!e.target.closest('.catlib-fan__item')) this.setFanActive(null);
          },
          true
        );
      }
    }

    query() {
      return this.searchInput ? this.searchInput.value.trim() : '';
    }

    matchesBrand(item) {
      return (
        this.selected.brand.size === 0 ||
        item.brands.some((b) => this.selected.brand.has(b.toLowerCase()))
      );
    }

    matchesIndustry(item) {
      return (
        this.selected.industry.size === 0 ||
        item.industries.some((i) => this.selected.industry.has(i.toLowerCase()))
      );
    }

    matchesActivity(item) {
      return (
        this.selected.activity.size === 0 ||
        item.activities.some((a) => this.selected.activity.has(a.toLowerCase()))
      );
    }

    /* Search-ranked items (with title match indices), or all items in block order.
       Memoized per query: one keystroke triggers this from the grid, the fan,
       and every filter-tile count, so the Fuse pass runs once, not 10+ times. */
    searchResults() {
      const q = this.query();
      if (!q || !this.fuse) {
        return this.items.map((item) => ({ item, matches: null }));
      }
      if (this.searchCache && this.searchCache.q === q) return this.searchCache.results;
      const results = this.fuse.search(q).map((r) => ({ item: r.item, matches: r.matches }));
      this.searchCache = { q, results };
      return results;
    }

    filteredResults() {
      return this.searchResults().filter(
        (r) => this.matchesBrand(r.item) && this.matchesIndustry(r.item) && this.matchesActivity(r.item)
      );
    }

    /* Tile count answers "what would I get if this were my only pick in this group";
       search and the other groups' selections still apply. */
    tileCount(group, value) {
      const key = value.toLowerCase();
      const base = this.searchResults();
      if (group === 'brand') {
        return base.filter(
          (r) =>
            r.item.brands.some((b) => b.toLowerCase() === key) &&
            this.matchesIndustry(r.item) &&
            this.matchesActivity(r.item)
        ).length;
      }
      if (group === 'industry') {
        return base.filter(
          (r) =>
            r.item.industries.some((i) => i.toLowerCase() === key) &&
            this.matchesBrand(r.item) &&
            this.matchesActivity(r.item)
        ).length;
      }
      return base.filter(
        (r) =>
          r.item.activities.some((a) => a.toLowerCase() === key) &&
          this.matchesBrand(r.item) &&
          this.matchesIndustry(r.item)
      ).length;
    }

    /* Merchant-set display label for a tag (Filter tile block), or the tag itself.
       Labels are display-only: filtering and counts always use the tag. */
    tileLabel(group, tag) {
      return this.labelMap[group].get(tag.toLowerCase()) || tag;
    }

    renderTiles() {
      if (!this.tilesEl) return;
      const tabValues = { brand: this.brands, industry: this.industries, activity: this.activities };
      const tabLabels = {
        brand: 'Filter by partner brand',
        industry: 'Filter by industry or solution',
        activity: 'Filter by activity'
      };
      const values = tabValues[this.activeTab] || [];
      this.tilesEl.setAttribute('role', 'group');
      this.tilesEl.setAttribute('aria-label', tabLabels[this.activeTab] || 'Filter catalogs');
      this.tilesEl.innerHTML = '';
      values.forEach((value) => {
        const n = this.tileCount(this.activeTab, value);
        const isSelected = this.selected[this.activeTab].has(value.toLowerCase());
        const shown = this.tileLabel(this.activeTab, value);
        const tile = document.createElement('button');
        tile.type = 'button';
        tile.className = 'catlib-tile';
        tile.classList.toggle('is-selected', isSelected);
        tile.classList.toggle('is-zero', n === 0);
        tile.setAttribute('aria-pressed', String(isSelected));
        tile.setAttribute('aria-label', shown + ', ' + n + ' result' + (n === 1 ? '' : 's'));
        const key = value.toLowerCase();
        const uploaded = this.iconMap[this.activeTab].get(key);
        const builtinIcons = {
          brand: BUILTIN_BRAND_ICONS,
          industry: BUILTIN_INDUSTRY_ICONS,
          activity: BUILTIN_ACTIVITY_ICONS
        };
        const builtin = (builtinIcons[this.activeTab] || {})[key];
        let icon = FALLBACK_ICON;
        let isWordmark = false;
        if (uploaded) {
          icon = `<img src="${uploaded}" alt="" loading="lazy">`;
        } else if (typeof builtin === 'string') {
          icon = builtin;
        } else if (builtin && builtin.img) {
          icon = `<img src="${builtin.img}" alt="" loading="lazy">`;
          isWordmark = !!builtin.wordmark;
        }
        if (isWordmark) tile.classList.add('catlib-tile--wordmark');
        tile.innerHTML =
          `<span class="catlib-tile__icon">${icon}</span>` +
          `<span class="catlib-tile__name"></span>` +
          (this.showCounts ? `<span class="catlib-tile__count">${n}</span>` : '');
        tile.querySelector('.catlib-tile__name').innerHTML = supTrademarks(shown);
        tile.addEventListener('click', () => {
          const key = value.toLowerCase();
          const set = this.selected[this.activeTab];
          /* Single-select per Browse-by group: picking a tile replaces the
             current pick; clicking the selected tile again deselects it */
          const wasSelected = set.has(key);
          set.clear();
          if (!wasSelected) set.add(key);
          this.renderAll();
        });
        this.tilesEl.appendChild(tile);
      });
    }

    renderChips() {
      if (!this.chipsEl) return;
      this.chipsEl.innerHTML = '';
      const displayName = (group, key) => {
        const lists = { brand: this.brands, industry: this.industries, activity: this.activities };
        const tag = (lists[group] || []).find((v) => v.toLowerCase() === key) || key;
        return this.tileLabel(group, tag);
      };
      ['brand', 'industry', 'activity'].forEach((group) => {
        this.selected[group].forEach((key) => {
          const chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'catlib-chip';
          chip.setAttribute('aria-label', 'Remove filter: ' + displayName(group, key));
          const label = document.createElement('span');
          label.className = 'catlib-chip__label';
          label.innerHTML = supTrademarks(displayName(group, key));
          chip.appendChild(label);
          const x = document.createElement('span');
          x.className = 'catlib-chip__x';
          x.setAttribute('aria-hidden', 'true');
          x.textContent = String.fromCharCode(215); // multiplication sign, kept ASCII-safe
          chip.appendChild(x);
          chip.addEventListener('click', () => {
            this.selected[group].delete(key);
            this.renderAll();
          });
          this.chipsEl.appendChild(chip);
        });
      });
      const hasFilters =
        this.selected.brand.size > 0 || this.selected.industry.size > 0 || this.selected.activity.size > 0;
      if (this.activeRow) this.activeRow.classList.toggle('has-filters', hasFilters);
    }

    highlightTitle(card, item, matches) {
      const titleEl = card.querySelector('[data-catlib-title]');
      if (!titleEl) return;
      const m = (matches || []).find((x) => x.key === 'title');
      if (!m) {
        titleEl.innerHTML = supTrademarks(item.title);
        return;
      }
      let out = '';
      let last = 0;
      m.indices.forEach(([s, e]) => {
        if (e - s < 1) return;
        out += supTrademarks(item.title.slice(last, s));
        out += '<mark>' + supTrademarks(item.title.slice(s, e + 1)) + '</mark>';
        last = e + 1;
      });
      out += supTrademarks(item.title.slice(last));
      titleEl.innerHTML = out;
    }

    renderGrid() {
      const results = this.filteredResults();
      const searching = this.query().length > 0;
      const browsing =
        this.selected.brand.size > 0 || this.selected.industry.size > 0 || this.selected.activity.size > 0;
      const sort = this.sortSelect ? this.sortSelect.value : this.dataset.defaultSort || 'new';

      /* Explicit sort choices (A to Z, Newest first) always win. On the default sort,
         browsing by tile falls back to alphabetical (block order means nothing
         mid-filter) and searches keep Fuse relevance order. */
      if (sort === 'alpha') {
        results.sort((a, b) => alphaCompare(a.item.title, b.item.title));
      } else if (sort === 'new') {
        results.sort(
          (a, b) =>
            b.item.date - a.item.date || b.item.isNew - a.item.isNew || a.item.idx - b.item.idx
        );
      } else if (sort === 'updated') {
        results.sort((a, b) => (b.item.isUpdated - a.item.isUpdated) || (a.item.idx - b.item.idx));
      } else if (sort === 'featured') {
        /* Curated block order; an active search keeps Fuse relevance instead */
        if (!searching) results.sort((a, b) => a.item.idx - b.item.idx);
      } else if (!searching && browsing) {
        results.sort((a, b) => alphaCompare(a.item.title, b.item.title));
      } else if (!searching) {
        results.sort((a, b) => a.item.idx - b.item.idx);
      }

      const visible = new Set(results.map((r) => r.item.idx));
      this.cards.forEach((card) => {
        const idx = parseInt(card.dataset.idx, 10);
        card.hidden = !visible.has(idx);
      });
      results.forEach((r) => {
        const card = this.cards[r.item.idx];
        if (!card) return;
        this.grid.appendChild(card);
        this.highlightTitle(card, r.item, searching ? r.matches : null);
      });

      if (this.countEl) {
        this.countEl.textContent = `${results.length} result${results.length === 1 ? '' : 's'}`;
      }
      if (this.emptyEl) this.emptyEl.hidden = results.length > 0;
      if (this.grid) this.grid.hidden = results.length === 0;
    }

    renderFan() {
      if (!this.fanEl) return;
      const filtering =
        this.query().length > 0 ||
        this.selected.brand.size > 0 ||
        this.selected.industry.size > 0 ||
        this.selected.activity.size > 0;
      const idxs = filtering
        ? this.filteredResults().map((r) => r.item.idx)
        : this.defaultFan;

      /* A new search or filter combination starts back at the first page */
      const setKey = (filtering ? 'f:' : 'd:') + idxs.join(',');
      if (setKey !== this.fanSetKey) {
        this.fanSetKey = setKey;
        this.fanPage = 0;
      }
      const pages = Math.max(1, Math.ceil(idxs.length / this.FAN_MAX));
      if (this.fanPage > pages - 1) this.fanPage = pages - 1;
      const start = this.fanPage * this.FAN_MAX;
      const shown = idxs.slice(start, start + this.FAN_MAX);

      const key = shown.join(',');
      if (key !== this.fanKey) {
        this.fanKey = key;
        this.buildFan(shown);
      }

      if (this.fanPrev && this.fanNext) {
        this.fanPrev.hidden = pages < 2;
        this.fanNext.hidden = pages < 2;
        this.fanPrev.disabled = this.fanPage === 0;
        this.fanNext.disabled = this.fanPage === pages - 1;
      }

      if (this.fanStatus) {
        const range = `${start + 1}-${start + shown.length}`;
        let msg = '';
        if (filtering) {
          if (idxs.length === 0) {
            msg = 'No catalogs match your search or filters.';
          } else {
            msg =
              idxs.length === 1
                ? `1 of ${this.items.length} catalogs matches`
                : `${idxs.length} of ${this.items.length} catalogs match`;
            if (pages > 1) msg += ` - showing ${range}`;
          }
        } else if (pages > 1) {
          msg = `${range} of ${idxs.length} catalogs`;
        }
        this.fanStatus.textContent = msg;
        this.fanStatus.hidden = msg === '';
      }
    }

    /* Hover pop scale: mirror the CSS cover-width formula, then aim the popped
       cover at ~240px wide. Capped at 1.65 so dense fans keep the big pop and
       sparse fans (already near the 185px max) stay on screen. n is set once
       from the initial fan count and only recomputed on resize, matching the
       pinned cover width. */
    updateFanPop(n) {
      if (!this.fanEl) return;
      this.fanN = Math.max(1, n || this.fanN || this.FAN_MAX);
      const width = Math.max(
        72,
        Math.min(185, (0.92 * window.innerWidth) / (2.2 + (this.fanN - 1) * 0.55))
      );
      const pop = Math.max(1.2, Math.min(1.65, 240 / width));
      this.fanEl.style.setProperty('--catlib-pop', pop.toFixed(3));
    }

    /* The cover whose layout slot contains the pointer's x. Slots come from
       untransformed offsets (offsetLeft ignores transforms), so the popped
       cover's scaled box never shifts the hit target under the pointer. Each
       cover owns the strip from its left edge to the next cover's left edge;
       the last cover owns its full width. */
    fanItemFromPoint(clientX) {
      const items = this.fanEl.querySelectorAll('.catlib-fan__item');
      if (!items.length) return null;
      const origin = (items[0].offsetParent || this.fanEl).getBoundingClientRect().left;
      const x = clientX - origin;
      let hit = null;
      items.forEach((el) => {
        if (x >= el.offsetLeft) hit = el;
      });
      const last = items[items.length - 1];
      if (hit === last && x > last.offsetLeft + last.offsetWidth) hit = null;
      return hit;
    }

    /* Single source of truth for the popped cover (mouse slot-tracking and
       touch tap-to-preview both land here) */
    setFanActive(item) {
      if (this.fanActive === item) return;
      if (this.fanActive) this.fanActive.classList.remove('is-active');
      this.fanActive = item || null;
      if (this.fanActive) this.fanActive.classList.add('is-active');
      this.fanEl.classList.toggle('has-active', !!this.fanActive);
    }

    /* Same geometry as the Liquid-rendered fan: covers sit on a circular arc
       (radius K cover-widths, from the uniform 0.55-width step) with rotation
       equal to the arc tangent, so every neighboring pair matches; the
       rightmost cover stacks on top. */
    buildFan(idxs) {
      const n = idxs.length;
      const spread = Math.min(40, 10 + n * 5);
      const dtheta = n > 1 ? (spread * (Math.PI / 180)) / (n - 1) : 1;
      const arcK = 0.55 / dtheta;
      const newTab = this.dataset.openNewTab === 'true';
      /* Cover width derives from the count in CSS, so keep it in sync */
      /* Cover width stays pinned to the initial fan count (--catlib-fan-n is
         set server-side and never updated), so filtering to fewer covers keeps
         the hero height stable instead of growing the covers and pushing the
         content below the fan down. */
      this.updateFanPop();
      /* The old covers are about to be detached, so drop the popped state */
      this.setFanActive(null);
      /* Covers are pooled per item and reused across re-fans, so images are
         decoded once and never churn while typing; only the per-slot rotation,
         arc drop, and stacking styles change. The is-refanning class kills the
         transform transition for one frame so repositioning reads as an
         instant re-fan (matching the old rebuild), not a slide. */
      this.fanNodes = this.fanNodes || new Map();
      this.fanEl.classList.add('is-refanning');
      this.fanEl.textContent = '';
      idxs.forEach((idx, i) => {
        const item = this.items[idx];
        if (!item) return;
        const t = n === 1 ? 0 : i / (n - 1) - 0.5;
        const r = t * spread;
        /* Arc drop in cover-widths (keep in sync with the Liquid fan loop) */
        const rad = Math.abs(r) * (Math.PI / 180);
        const f = arcK * (1 - Math.cos(rad));
        let el = this.fanNodes.get(idx);
        if (!el) {
          el = document.createElement(item.url ? 'a' : 'div');
          el.className = 'catlib-fan__item';
          if (item.url) {
            el.href = item.url;
            if (newTab) {
              el.target = '_blank';
              el.rel = 'noopener';
            }
            el.setAttribute(
              'aria-label',
              'View the ' + item.title + (newTab ? ' (opens in a new tab)' : '')
            );
          }
          if (item.img) {
            const img = document.createElement('img');
            img.src = item.img;
            img.alt = '';
            img.loading = 'lazy';
            el.appendChild(img);
          }
          if (item.badge) {
            const badge = document.createElement('span');
            badge.className = 'catlib-badge catlib-badge--fan';
            badge.textContent = item.badge;
            el.appendChild(badge);
          }
          const label = document.createElement('span');
          label.className = 'catlib-fan__label';
          label.setAttribute('aria-hidden', 'true');
          label.innerHTML = supTrademarks(item.title);
          el.appendChild(label);
          this.fanNodes.set(idx, el);
        }
        el.style.setProperty('--r', r.toFixed(2) + 'deg');
        el.style.setProperty('--f', f.toFixed(4));
        el.style.setProperty('--z', String(i + 1));
        this.fanEl.appendChild(el);
      });
      requestAnimationFrame(() => this.fanEl.classList.remove('is-refanning'));
    }

    /* One row hosts chips, the Browse all toggle, count, sort, and Clear all.
       While the browse area is collapsed the row stays (it owns the toggle)
       but count and sort hide via .is-collapsed, so shoppers only see filter
       feedback: chips + Clear all next to Browse all. Without a fan hero there
       is no toggle and the row simply follows the always-open browse area. */
    updateActiveRow() {
      if (!this.activeRow) return;
      const active =
        this.query().length > 0 ||
        this.selected.brand.size > 0 ||
        this.selected.industry.size > 0 ||
        this.selected.activity.size > 0;
      const collapsed = !!(this.browseEl && this.browseEl.hidden);
      this.activeRow.classList.toggle('is-collapsed', collapsed);
      this.activeRow.hidden = collapsed && !active && !this.browseAllBtn;
    }

    renderAll() {
      if (this.searchBox) this.searchBox.classList.toggle('has-value', this.query().length > 0);
      this.renderTiles();
      this.renderChips();
      this.renderGrid();
      this.renderFan();
      this.updateActiveRow();
    }

    resetAll() {
      if (this.searchInput) this.searchInput.value = '';
      this.selected.brand.clear();
      this.selected.industry.clear();
      this.selected.activity.clear();
      if (this.sortSelect) {
        this.sortSelect.value = this.dataset.defaultSort || 'new';
        if (this.sortSelect.selectedIndex < 0) this.sortSelect.selectedIndex = 0;
      }
      this.renderAll();
    }
  }

  if (!customElements.get('catalog-library')) {
    customElements.define('catalog-library', CatalogLibrary);
  }
})();
